import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

/** Stat-ladder glyph (Figma Football hub · ListItem-Toggle): three rungs fading upward. */
export const CustomLadder = (props: SvgIconProps): JSX.Element => {
    return (
        <SvgIcon {...props} viewBox="0 0 20 20">
            <path d="M3.69792 19.375C3.36806 19.375 3.10764 19.2405 2.91667 18.9714C2.72569 18.7023 2.67361 18.4115 2.76042 18.099L3.84898 14.1667H13.8441L12.6042 18.6458C12.5347 18.8715 12.4132 19.0495 12.2396 19.1797C12.066 19.3099 11.8663 19.375 11.6406 19.375C11.2934 19.375 11.0243 19.2405 10.8333 18.9714C10.6424 18.7023 10.5903 18.4115 10.6771 18.099L11.1979 16.25H5.33854L4.6875 18.6458C4.61806 18.8715 4.49219 19.0495 4.3099 19.1797C4.1276 19.3099 3.92361 19.375 3.69792 19.375Z" />
            <path
                opacity="0.3"
                d="M7.76042 0.820312C7.58681 0.950521 7.46528 1.12847 7.39584 1.35417L5.29079 8.95833H7.36979L8.22917 5.83333H14.0625L13.2031 8.95833H15.2859L17.2396 1.90104C17.3264 1.58854 17.2743 1.29774 17.0833 1.02865C16.8924 0.759549 16.6319 0.625 16.3021 0.625C16.0764 0.625 15.8724 0.690104 15.6901 0.820312C15.5078 0.950521 15.3819 1.12847 15.3125 1.35417L14.6615 3.75H8.80209L9.32292 1.90104C9.40972 1.58854 9.35764 1.29774 9.16667 1.02865C8.9757 0.759549 8.7066 0.625 8.35938 0.625C8.13368 0.625 7.93403 0.690104 7.76042 0.820312Z"
            />
            <path
                opacity="0.6"
                d="M12.6302 11.0417L11.7708 14.1667H13.8441L15.2859 8.95833H5.29079L3.84898 14.1667H5.9375L6.79688 11.0417H12.6302Z"
            />
        </SvgIcon>
    );
};
